import { candleParser } from "../candleParser";
/**
 * example message:
 * {
	"messageType": "alertNotification",
	"notificationId": 1645473057989,
	"notificationDetails": {"updateType":"ENTRY_TRIGGERED","notificationType":"TRADE_PLAN_UPDATE","TRADE_PLAN":{"type":"BASIC_TRADING_SYSTEM","id":1,"symbol":"XYZ"}},
	"status": "TACTIC_TRIGGERED",
	"statusDetails": {"pluginTemplate":{"candleDuration":1,"timeUnit":"MINUTES","candle":{"high":100.2,"low":100.2,"open":100.2,"close":100.2,"candleSymbol":"XTz","candleStartTimeStamp":1641110640000,"duration":"1min"}},"triggerPrice":100.2,"tradeDirection":"LONG","tacticName":"CANDLE_BREAK","symbol":"xyz"},
	"date": "2022-02-21T14:50:58.633-0500",
	"timestamp": "1645473058635"
}

 * @param {*} pluginTemplate 
 * @returns object with fields:
 * 1) candleDuration
 * 2) timeUnit
 * 3) candle (object with fields: high,low,open,close,candleSymbol,duration,candleStartTimeStamp)
 */
export function candleBreakParser(pluginTemplate) {
    const parsedObject = {
        candleDuration: null,
        timeUnit: null,
        candle: null,
    }
    if(pluginTemplate) {
        parsedObject.candleDuration=pluginTemplate.candleDuration;
        parsedObject.timeUnit=pluginTemplate.timeUnit;
        const candle = candleParser(pluginTemplate.candle);
        if(candle) {
            parsedObject.candle=candle;
        }
    }
    return parsedObject;
}